import { ModalProps, withModalConditionalRender } from '@billy/design-system'
import { ReactElement } from 'react'

import { Account } from '@modules-deprecated/app/accounts/types'

import { UpdateAccountFromTemplateFormContextProvider } from './contexts'
import { UpdateAccountFromTemplateModalComponent } from './elements/UpdateAccountFromTemplateModalComponent'

interface UpdateAccountFromTemplateProps extends ModalProps {
  account?: Account
  onClose?: () => void
  onSave?: () => void
}

const UpdateAccountFromTemplate = ({
  account,
  onClose,
  onSave,
  ...modalProps
}: UpdateAccountFromTemplateProps): ReactElement => {
  return (
    <UpdateAccountFromTemplateFormContextProvider account={account} onClose={onClose} onSave={onSave}>
      <UpdateAccountFromTemplateModalComponent {...modalProps} />
    </UpdateAccountFromTemplateFormContextProvider>
  )
}

export const UpdateAccountFromTemplateModal = withModalConditionalRender(UpdateAccountFromTemplate)
